import { useState } from "react";
import styled from "styled-components";
import MortgageLeaders from "../../components/MortgageLeaders";
import MortgageSteps from "../../components/MortgageSteps";
import EmiCalculator from "../../components/EmiCalculator";
import bgimg from "../../assets/images/bg.jpg";
import whyuwait from "../../assets/images/whyuwait.png";


const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 80vh;
  overflow: hidden;

  @media (max-width: 668px) {
    height: 60vh;
  }
`;

const BackgroundImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: 0;
  left: 0;
  z-index: 0;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgb(0 0 0 / 71%);
  z-index: 1;
`;
const FlexContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: white;
  padding: 0 20px;
  text-align: center;

  h1 {
    font-size: 5rem;
    color: #fff;
    margin-bottom: 1rem;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }
  }
`;

const Section = styled.div`
  font-family: "Poppins", sans-serif;
  padding: 40px 20px;
  background-color: #fff;
  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`;

const Container = styled.div`
  max-width: 1300px;
  margin: auto;
  padding: 0 20px;
  @media (max-width: 768px) {
    padding: 0px;
  }
  @media (min-width: 1200px) {
    padding: 0 40px;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #111;
  font-family: "Paris Avenue";

  @media (min-width: 768px) {
    font-size: 28px;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
  }
`;
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

const Col = styled.div`
  width: 50%;
  padding: 1rem;

  @media (max-width: 768px) {
    width: 100%;
     padding: 0rem;
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: #333;

      @media (max-width: 768px) {
      font-size: 1.5rem;
      margin:0px;
      }
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    color: #666;
  }
`;
const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const Mortgage = () => {
  const [modalOpened, setModalOpened] = useState(false);

  // Effect to automatically open modal when the page loads
  // useEffect(() => {
  //   setModalOpened(true);
  // }, []);
  return (
    <div>
      <BackgroundWrapper>
        <BackgroundImage src={bgimg} />
        <Overlay />

        <FlexContainer>
          <h1>
            Connect with the
            <br /> Morgast Expert
          </h1>
        </FlexContainer>
      </BackgroundWrapper>
      <Section>
        <Container>
          <Title>Plan your finances with our mortgage calculator</Title>
          {/* <EmiCalculator/> */}
          <EmiCalculator />
        </Container>
      </Section>
      <MortgageLeaders id="whyus" />
      <Section>
        <Container>
          <Title style={{ marginBottom: "0px" }}>The mortgage process</Title>
          <p>
            From application to approval, we've simplified every step to make
            your dream home a reality. Explore below to see how easy it can be.
          </p>
          <MortgageSteps />
        </Container>
      </Section>

      <Section>
        <Container>
          <Row>
            <RowWrapper>
              <Col>
                <StyledImage src={whyuwait} alt="Home" />
              </Col>
              <Col>
                <Content>
                  <h2>
                    Why wait 2 months? <br /> Get a mortgage in 2 weeks
                  </h2>
                  <p>
                    We work closely with our bank partners to deliver you
                    exclusive offers that can only be accessed through{" "}
                    <b>THE EMBARK</b>.
                  </p>
                </Content>
              </Col>
            </RowWrapper>
          </Row>
        </Container>
      </Section>

      {/* <Information id="intro" /> 
      <Services id="services"  video={cover3}/> */}
      {/* <Brands id="brands" />  */}

      {/* <EmbrakSection />
      <Testimonials id="testi" />
      <ArticleGrid/>
      <ContactUs id="contactus" />
      <Modal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        centered
        withCloseButton
        size="lg" 
        overlayBlur={3}
        overlayColor="rgba(0, 0, 0, 0.6)" 
        transition="fade"
        transitionDuration={300}
        styles={{
          modal: {
            borderRadius: "20px",
            background: "#fff", 
          },
        }}
      >
        <ContactUs />
      </Modal> */}
    </div>
  );
};

export default Mortgage;
